// extracted by mini-css-extract-plugin
export default {"tab-filled_chosen":"TabFilled_tab-filled_chosen__9d8Rz"};